export const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-[var(--vsl-bg)]" data-testid="page-loader">
    <span className="block w-2.5 h-2.5 rounded-full bg-[var(--vsl-fg)] vsl-breathe" />
  </div>
);
